module.exports = __webpack_public_path__ + "img/ship.554b20ed.svg";